module.exports = __webpack_public_path__ + "static/media/niveau-01.b5125350.png";